export const SITE_NAME = "Bronflix";

export const MEDIA_URL = "https://api.themoviedb.org/3/";
export const MEDIA_IMG_URL = "https://image.tmdb.org/t/p/";
export const EMAILJS_PUBLIC_KEY = "Z6SWDyMbtxfzu4GzU";

export const MOVIE_CHANGE_INTERVAL = 10000;

export const MOVIES_FEATURED_QUANTITY = 15;
export const MOVIES_TOP_RATED_QUANTITY = 18;
export const SHOWS_TRENDING_QUANTITY = 20;
export const SHOWS_TRENDING_QUANTITY_MD = 12;
export const SHOWS_TOP_RATED_QUANTITY = 16;
export const SHOWS_TOP_RATED_QUANTITY_MD = 12;
export const ACTORS_TRENDING_QUANTITY = 20;
export const ACTORS_TRENDING_QUANTITY_MD = 12;

export const BASE_GAP = 15;
export const BASE_GAP_CLASS = `gap-${BASE_GAP / 2.5}`;
export const SCROLL_BY_ONE_MULTIPLIER = 3;
export const BIO_PREVIEW_LENGTH = 400;

export const MOBILE_PREVIEW_WIDTH = "10rem";
export const MOBILE_PREVIEW_HEIGHT = "15rem";

export const CAST_MAX = 25;
export const CREW_MAX = 15;
export const MAX_OVERVIEW_CHARS = 250;
export const NOTABLE_WORK_LIMIT = 15;
export const NOTABLE_POPULARITY_LIMIT = 4;
export const NOTABLE_SCORE_LIMIT = 7.5;
export const NOTABLE_SCORE_SECONDARY = 7;
export const NOTABLE_SCORE_LAST = 6.5;

export const MIN_SEARCH_CHARS = 2;
export const SEARCH_RESULTS_PAGE = 20;
export const MAX_RESULTS = 10000;
export const MAX_PAGINATION = 500;
export const MAX_RESULTS_PER_PAGE = 20;

export const FILMOGRAPHY_LIMIT = 40;
export const EXCLUDED_GENRE_IDS = [
  99, // Documentary
  10762, // Kids
  10763, // News
  10764, // Reality
  10767, // Talk
];

export const COLLECTION_IDS = [
  10, 119, 263, 264, 295, 328, 528, 645, 748, 1241, 2150, 8091, 9485, 10194,
  86311, 87359,
];

export const SEASON_TYPES = ["specials"];

export const CREW_JOBS = [
  "Director",
  "Writer",
  "Novel",
  "Screenplay",
  "Original Music Composer",
  "Director of Photography",
  "Producer",
  "Executive Producer",
  "Production",
];

export const GENDERS = ["N/A", "Female", "Male"];

export const DEFAULT_TITLES = [
  "Lord Master",
  "The Chosen One",
  "The Last Action Hero",
  "The One Who Knocks",
  "The Hero of Time",
  "The Ringbearer",
  "The Dark Knight",
  "Wizarding Prodigy",
  "The Time Traveler",
  "The Caped Crusader",
  "Ghostbuster",
  "Space Cowboy",
  "True Believer",
  "Vault Dweller",
  "Master Builder",
  "Gladiator",
  "Animus Explorer",
  "Blade Runner",
  "Relic Hunter",
  "Cybernetic Rebel",
  "Hogwarts Student",
  "Avenger in Training",
  "Cybernetic Protector",
  "Friendly Neighborhood Spider",
  "Starfighter Ace",
  "Sorcerer Supreme",
  "Fellowship Seeker",
  "Jedi Knight",
  "Dark Lord of the Sith",
  "Hidden Assassin",
  "The Mad Titan",
  "Quantum Wanderer",
  "Moonlight Assassin",
  "Paradox Seeker",
  "Phantom Rider",
  "Rogue Operator",
  "Eternal Guardian",
  "Crimson Outlaw",
  "Arc Reactor Adept",
  "Wasteland Nomad",
  "Invincible Titan",
];
